<!-- #region New Design -->
<div class="col-12">
    <div class="clientportal-app-card">
        <!-- BODY -->
        <div id="cardCollapse-userInfo">
            <div class="clientportal-app-card-body">
                <div class="row g-3">
                    <div class="col-sm-12">
                        <div class="row g-3">
                            <div class="col-sm-6 col-xl-2">
                                <div class="profile-image symbol" [class.loading]="!_userRequestCompletedFlag" (click)="imageInput.click()">
                                    <input #imageInput type="file" (change)="handleFileUpload(imageInput)" class="d-none" accept="image/jpeg, image/png">
                                    <img class="full-image" [src]="avatarSafeUrl ?? 'assets/media/avatars/blank.png'" >
                                    <span *ngIf="!_userRequestCompletedFlag"></span>
                                </div>
                            </div>

                            <ng-container *ngIf="_userRequestCompletedFlag">
                                <div class="col-3 ms-10 d-flex flex-column justify-content-center">
                                    <span class="mb-2 fa-2x fw-bold overflow-show"> {{ userData.firstName + ' ' + userData.lastName }} </span>
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="border border-dashed border-1 border-mv-gray rounded py-2 px-3">
                                                <span class="fw-bold">{{ contractsCount }}</span>
                                                <br>
                                                <span class="text-mv-gray">{{ 'CONTRACTS' | translate }}</span>
                                            </div>
                                        </div>
                        
                                        <div class="col-auto">
                                            <div class="border border-dashed border-1 border-mv-gray rounded py-2 px-3">
                                                <span class="fw-bold">{{ supplyPointsCount }}</span><br>
                                                <span class="text-mv-gray">{{ 'CONSUMPTION_POINTS' | translate }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- save button moved into the Personal Data card header -->
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="tabLayout$ | async as tabLayout">
    <div class="col-12">
        <is-tab-layout [tabLayout$]="tabLayout$" (onSelectedTab)="onTabChange($event)"></is-tab-layout>
    </div>
</ng-container>

<div class="col-12">
    <div class="clientportal-app-card">
        <!-- HEADER -->
        <div class="clientportal-app-card-header d-flex align-items-center">
            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1">
                <h3 class="clientportal-app-card-title m-6">
                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                    {{ 'PERSONAL_DATA' | translate }}
                </h3>
            </div>
            <div class="clientportal-app-card-toolbar">
                <button class="btn btn-success btn-icon save-button" *ngIf="_alteredFormFlag" (click)="submitProfile()">
                    <i class="fas fa-floppy-disk"></i>
                </button>
            </div>
        </div>

        <!-- BODY -->
        <div id="cardCollapse-userInfo">
            <div class="clientportal-app-card-body">
                <form [formGroup]="userForm">
                    <ng-container *ngIf="selectedTab == 0">
                        <div class="row g-3">
                            <div class="col-sm-12">
                                <div class="row g-3">
                                    <!-- First Name -->
                                    <div class="col-sm-6 col-xl-4">
                                        <label class="text-muted small fw-medium">{{ 'FIRST_NAME' | translate }}</label>
                                        <div class="">
                                            <input class="form-control form-control-solid" formControlName="firstName" type="text">
                                        </div>
                                    </div>

                                    <!-- Last Name -->
                                    <div class="col-sm-6 col-xl-4">
                                        <label class="text-muted small fw-medium">{{ 'LAST_NAME' | translate }}</label>
                                        <div class="">
                                            <input class="form-control form-control-solid" formControlName="lastName" type="text">
                                        </div>
                                    </div>

                                    <!-- Birth Date -->
                                    <div class="col-sm-6 col-xl-4">
                                        <label class="text-muted small fw-medium">{{ 'BIRTH_DATE' | translate }}</label>
                                        <div class="">
                                            <is-date-time-picker [Type]="dateType" formControlName="birthDate" [dateLimits]="dateLimits"></is-date-time-picker>
                                        </div>
                                    </div>

                                    <!-- TIN -->
                                    <div class="col-sm-6 col-xl-4">
                                        <label class="text-muted small fw-medium" for="tin">{{ 'TIN' | translate }}</label>
                                        <div class="">
                                            <input class="form-control form-control-solid" formControlName="tin" type="text">
                                        </div>
                                    </div>

                                    <!-- Cellphone -->
                                    <div class="col-sm-6 col-xl-4">
                                        <label class="text-muted small fw-medium">{{ 'CELLPHONE' | translate }}</label>
                                        <div class="">
                                            <input #phone class="form-control form-control-solid w-100" id="phone" formControlName="contactNumber" type="tel">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="selectedTab == 1">
                        <div class="row g-3">
                            <div class="col-sm-12">
                                <div class="row g-3">
                                    <!-- Email -->
                                    <div class="col-sm-6 col-xl-4">
                                        <label class="text-muted small fw-medium">{{ 'EMAIL' | translate }}</label>
                                        <div class="">
                                            <input class="form-control form-control-solid" type="text" [value]="userData.email" [readonly]="true" [contentEditable]="false">
                                        </div>
                                    </div>

                                    <!-- Password -->
                                    <div class="col-sm-6 col-xl-4">
                                        <label class="text-muted small fw-medium">{{ 'PASSWORD' | translate }}</label>
                                        <div class="">
                                            <button class="btn btn-secondary p-3"> {{ 'REQUEST_PASSWORD_CHANGE' | translate }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- #endregion -->